<template>
    <div class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 class="text-xl font-bold mb-4 text-gray-800">Add Client</h2>
        <form @submit.prevent="submitClient">
          <input v-model="client.name" class="w-full p-2 border rounded-lg mb-4" placeholder="Name" required />
          <input v-model="client.phone" type="phone" class="w-full p-2 border rounded-lg mb-4" placeholder="Phone" required />
          <input v-model="client.email" type="email" class="w-full p-2 border rounded-lg mb-4" placeholder="Email" required />
          <input v-model="client.address" type="address" class="w-full p-2 border rounded-lg mb-4" placeholder="Address" required />
          <input v-model="client.password" type="password" class="w-full p-2 border rounded-lg mb-4" placeholder="Password" required />
          <input v-model="client.repeatPassword" type="password" class="w-full p-2 border rounded-lg mb-4" placeholder="Repeat Password" required />
          <button type="submit" class="w-full bg-green text-white p-2 rounded-lg">Add Client</button>
        </form>
        <button @click="closeModal" class="mt-4 w-full text-gray-600">Cancel</button>
      </div>
    </div>
  </template>
  
  <script>
import { mapActions } from 'vuex';

  export default {
    data() {
      return {
        client: {
          name: '',
          phone: '',
          email: '',
          address : '',
          password : '',
          repeatPassword: '',
        },
      };
    },
    methods: {
      ...mapActions('clients', { fetchClients: 'fetchClients', addClient : 'addClient' }),
      submitClient() {
        this.addClient(this.client);
        this.closeModal();
      },
      closeModal() {
        this.$emit('closeModal');
      },
    },
  };
  </script>
  